import { getSvgIcon, Icon } from '@helpers/icons';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Pagination.styles';
const Pagination = ({ disabled = false, margin = 2, pageSize, totalCount, value, onChange, ariaLabelNext = 'Next page', ariaLabelPrevious = 'Previous page', }) => {
    // Get the number of possible pages.
    const pageCount = Math.ceil(totalCount / pageSize);
    // Create array of values for all pages.
    const pageArray = Array.from(Array(pageCount)).map((_, index) => index + 1);
    // Reduce array to the items before and after the current value.
    const beforeStart = Math.max(value - margin - 1, 0);
    const beforeEnd = Math.max(value - 1, 0);
    const before = pageArray.slice(beforeStart, beforeEnd);
    const afterStart = Math.min(value, pageCount);
    const afterEnd = Math.min(value + margin, pageCount);
    const after = pageArray.slice(afterStart, afterEnd);
    // Determine whether to show first/last page numbers.
    const showFirst = before[0] > 1;
    const showLast = after[after.length - 1] < pageCount;
    if (pageCount < 2) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Item, { "aria-label": ariaLabelPrevious, disabled: disabled || value === 1, type: "button", onClick: (event) => {
                    event.preventDefault();
                    onChange(Math.max(value - 1, 1));
                }, "data-prev": true }, getSvgIcon(Icon.ChevronDown))),
        React.createElement(S.List, null,
            showFirst && (React.createElement(React.Fragment, null,
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.Item, { key: "1", disabled: disabled, type: "button", onClick: (event) => {
                            event.preventDefault();
                            onChange(1);
                        } }, 1)),
                React.createElement(S.Separator, null, "\u2026"))),
            before.length > 0 && (React.createElement(React.Fragment, null, before.map((page, i) => (React.createElement(FocusRing, { key: page, focusRingClass: "focus-ring" },
                React.createElement(S.Item, { disabled: disabled, type: "button", onClick: (event) => {
                        event.preventDefault();
                        onChange(page);
                    }, "data-hidden-mobile": (showFirst && showLast) || (showLast && i === 0) }, page.toString())))))),
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.Item, { disabled: true, type: "button", "aria-current": "page", onClick: (event) => {
                        event.preventDefault();
                        onChange(value);
                    } }, value)),
            after.length > 0 && (React.createElement(React.Fragment, null, after.map((page, i) => (React.createElement(FocusRing, { key: page, focusRingClass: "focus-ring" },
                React.createElement(S.Item, { disabled: disabled, type: "button", onClick: (event) => {
                        event.preventDefault();
                        onChange(page);
                    }, "data-hidden-mobile": (showFirst && showLast) || (showFirst && i > 0) }, page)))))),
            showLast && (React.createElement(React.Fragment, null,
                React.createElement(S.Separator, null, "\u2026"),
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.Item, { disabled: disabled, type: "button", onClick: (event) => {
                            event.preventDefault();
                            onChange(pageCount);
                        } }, pageCount))))),
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Item, { "aria-label": ariaLabelNext, disabled: disabled || value === pageCount, type: "button", onClick: (event) => {
                    event.preventDefault();
                    onChange(Math.min(value + 1, pageCount));
                }, "data-next": true }, getSvgIcon(Icon.ChevronDown)))));
};
export default Pagination;
